import { Grid } from '@mui/material'
import React, { Children, type ReactNode } from 'react'

interface StackLayoutProps {
  children: ReactNode[] | ReactNode
  height?: number | string
  maxWidth?: number | string
  alignItems?: string
  justifyContent?: string
}

const StackRowLayout: React.FunctionComponent<StackLayoutProps> = ({
  children, height, maxWidth,
  alignItems, justifyContent,
}) => {
  const childrenArray = Children.toArray(children)

  return (
    <Grid
      container
      height='calc(100% - 50px)'
      margin='auto'
      maxWidth={(maxWidth != null) ? maxWidth : '2400px'}
      justifyContent='center'
    >
      {
        Children.map(childrenArray, (child, index) => {
          return (
            <Grid
              item xs
              height={(height != null) ? height : '800px'}
              sx={{
                display: 'flex',
                alignItems: (alignItems != null ? alignItems : 'center'),
                justifyContent: (justifyContent != null ? justifyContent : 'center'),
              }}
            >
              {child}
            </Grid>
          )
        })
      }
    </Grid>
  )
}

export default StackRowLayout
